import { Component, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import {ShippingDetails, StoreLocation} from 'src/app/shared-core/models/cart-data.model';

@Component({
    selector: 'app-pickup-selector',
    templateUrl: './pickup-selector.component.html',
    styleUrls: ['./pickup-selector.component.scss']
})
export class PickupSelectorComponent {
    @Input() public pageScope: string;
    @Input() public locationsForm: FormGroup;
    @Input() public storeLocations: StoreLocation[] = [];
    @Input() public shippingDetails: ShippingDetails;
    @Input() public stockMap: Map<string, {
        allInStock: boolean,
        allOutOfStock: boolean,
        partiallyInStock: boolean
    }>
        
    @ViewChild('instructionsModal') instructionsModal: ModalDirective;
    public modalConfig = {
        ignoreBackdropClick: true,
        animated: true,
        backdrop: true
    };

    public get isReady(): boolean {
        return Boolean(this.locationsForm) && Boolean(this.shippingDetails) && this.storeLocations.length > 0;
    }

    public get isCartPage(): boolean {
        return this.pageScope === 'cart';
    }

    public showModal(event: UIEvent): void {
        this.instructionsModal.show();
        event.preventDefault();
    }
}